module.exports = "<svg fill=\"#000000\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"></path><path d=\"M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader!./src/assets/svg/navigation.vue.svg
// module id = DUHf
// module chunks = 1